<template>
  <div class="table-responsive logwork-table-wrapper" ref="wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: "LogworkStickyWrapper",
  mounted() {
    // Initial calculation
    this.updateOffsets();
    // Recalculate on resize and scroll
    window.addEventListener("resize", this.updateOffsets);
    const wrapper = this.$refs.wrapper;
    if (wrapper) wrapper.addEventListener("scroll", this.updateOffsets);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateOffsets);
    const wrapper = this.$refs.wrapper;
    if (wrapper) wrapper.removeEventListener("scroll", this.updateOffsets);
  },
  methods: {
    updateOffsets() {
      const wrapper = this.$refs.wrapper;
      if (!wrapper) return;
      const table = wrapper.querySelector("table");
      if (!table) return;

      const issueTh = table.querySelector("th.col-issue");
      const sumTh = table.querySelector("th.col-sum");
      const issueWidth = issueTh ? Math.round(issueTh.offsetWidth) : 220;
      const sumWidth = sumTh ? Math.round(sumTh.offsetWidth) : 70;
      const frozenWidth = issueWidth + sumWidth;

      wrapper.style.setProperty("--col0-left", `0px`);
      wrapper.style.setProperty("--col1-left", `${issueWidth}px`);
      wrapper.style.setProperty("--frozen-width", `${frozenWidth}px`);
      const sbH = Math.max(0, wrapper.offsetHeight - wrapper.clientHeight - 2);
      wrapper.style.setProperty("--sb-h", `${sbH}px`);
    }
  }
};
</script>

<style scoped>
.table-responsive.logwork-table-wrapper {
  position: relative;
  overflow-x: auto; /* scroll container so sticky left works on th/td */
}
</style>
